import React from 'react';
import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';
import { Delete } from '@mui/icons-material';
import { TableCell, TableRow, Tooltip, FormControlLabel, Checkbox, IconButton } from '@mui/material';
import { Autocomplete } from '@totalsoft/rocket-ui';
import { isValid, getErrors } from '@totalsoft/pure-validations-react';
import { TextField } from '@totalsoft/rocket-ui';

const EngineScoringClassificationCategoryListItemComponent = ({
  category,
  dispatch,
  isReadOnly,
  scoringCategoryOptions,
  categoryIndex,
  validation,
  classificationIndex
}) => {
  const { t } = useTranslation();
  const onPropertyChanged = (property, propertyValue, propertyName, propertyNameValue) => {
    dispatch({
      type: 'OnClassificationCategoryChanged',
      property,
      propertyValue,
      propertyName,
      propertyNameValue,
      categoryIndex,
      classificationIndex
    });
  };

  const onDeleteCategory = () => {
    dispatch({
      type: 'OnClassificationCategoryDeleted',
      key: category.engineScoringClassificationXScoringId,
      categoryIndex,
      classificationIndex
    });
  };

  return (
    <TableRow hover>
      <TableCell>
        <TextField
          isNumeric
          fullWidth
          decimalScale={0}
          value={category.orderNo}
          disabled={isReadOnly}
          onChange={event => onPropertyChanged('orderNo', event)}
          error={!isValid(validation.orderNo)}
          helperText={getErrors(validation.orderNo)}
        />
      </TableCell>
      <TableCell>
        <Autocomplete
          fullWidth
          valueKey='scoringId'
          value={{ scoringId: category.scoringId, name: category.scoringName }}
          options={scoringCategoryOptions}
          isDisabled={isReadOnly}
          onChange={event =>
            onPropertyChanged('scoringId', event !== null ? event.scoringId : null, 'scoringName', event !== null ? event.name : null)
          }
          error={!isValid(validation.scoringId)}
          helperText={getErrors(validation.scoringId)}
          isSearchable={true}
        />
      </TableCell>
      <TableCell>
        <FormControlLabel
          control={
            <Checkbox
              checked={category.readOnlyCategory || false}
              disabled={isReadOnly}
              onChange={event => onPropertyChanged('readOnlyCategory', event.target.checked)}
              color='primary'
            />
          }
        />
      </TableCell>
      <TableCell>
        <FormControlLabel
          control={
            <Checkbox
              checked={category.isMandatory || false}
              disabled={isReadOnly}
              onChange={event => onPropertyChanged('isMandatory', event.target.checked)}
              color='primary'
            />
          }
        />
      </TableCell>
      <TableCell>
        <Tooltip title={t('EngineScoring.EngineClassifications.EngineCategory.DeleteTooltip')}>
          <span>
            <IconButton color='primary' onClick={onDeleteCategory} disabled={isReadOnly}>
              <Delete />
            </IconButton>
          </span>
        </Tooltip>
      </TableCell>
    </TableRow>
  );
};

EngineScoringClassificationCategoryListItemComponent.propTypes = {
  category: PropTypes.object.isRequired,
  dispatch: PropTypes.func.isRequired,
  isReadOnly: PropTypes.bool.isRequired,
  scoringCategoryOptions: PropTypes.array.isRequired,
  categoryIndex: PropTypes.number.isRequired,
  classificationIndex: PropTypes.number.isRequired,
  validation: PropTypes.object.isRequired
};

export default EngineScoringClassificationCategoryListItemComponent;
